import type * as React from 'react';

import type { MarkProps, Plugin } from '@gitbook/slate-react';

export const SELECTION_HIGHLIGHTING_MARK = 'selectionHighlighting';

/**
 * Slate plugin to highlight a selection when the editor is not focused.
 */
export const selectionHighlightingPlugin: Plugin = {
    renderMark,
};

function renderMark(props: MarkProps) {
    const { mark } = props;

    switch (mark.type) {
        case SELECTION_HIGHLIGHTING_MARK:
            return <SelectionHighlighting {...props} />;
    }
}

function SelectionHighlighting(props: MarkProps): React.ReactElement {
    const { attributes, children } = props;

    return (
        <span
            {...attributes}
            style={{
                // We use a native span DOM element because RNW doesn't support Highlight as a color value
                backgroundColor: 'Highlight',
                color: 'HighlightText',
            }}
        >
            {children}
        </span>
    );
}
